import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "c-link text-left"
}
const _hoisted_2 = { class: "c-magic-line c-magic-line--underline whitespace-nowrap" }


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerMiniButton',
  props: {
    label: { default: undefined }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", { class: "c-magic-line c-magic-line--underline whitespace-nowrap" }, () => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ])
    ])
  ]))
}
}

})